module.exports = __webpack_public_path__ + "img/p_heavyduty.e2a5e9b0.jpg";